import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import PageHeader from "../components/pageHeader"

const SCHOOL_URL = "https://www.csustan.edu/"

export default function About() {
  return (
    <Layout>
      <PageHeader>About</PageHeader>

      Software Engineer from California

      <br />
      <br />

      I finished my Bachelor's degree in Computer Science Fall of 2021 
      at <a href={SCHOOL_URL}>California State University, Stanislaus</a>.

      <br />
      <br />

      Working on a Game Boy emulator written in Go right now.

      <br />
      <br />

      Let's <Link to="/contact/">Connect!</Link> o(*￣▽￣*)ブ

    </Layout>
  )
}
